import axios from 'src/utils/axios';

export const NavBarAdetleriAl = (serviceShopId, TechnicianId) => {
  axios.get(`/GetArtemisAdetler/${serviceShopId}/${TechnicianId}`)
    .then((response) => {
      const res = response.data;
      res.length > 0 && res.forEach((r) => {
        switch (r.TIP) {
          case 'ISLER':
            setIslerAdet(r.ADET);
            break;
          case 'YORUM':
            setYorumAdet(r.ADET);
            break;
          case 'UYARI':
            setUyariAdet(r.ADET);
            break;
          case 'MALZEME_IHTIYAC':
            setMalzemeIhtiyacAdet(r.ADET);
            break;
          default:
            break;
        }
      });
    }).catch((error) => {
    });
};


export const getIslerAdet = () => sessionStorage.getItem('IsAdet') || null;
export const getClosedJobCount = () => sessionStorage.getItem('ClosedJobCount') || null;

export const setIslerAdet = (Adet) => {
  sessionStorage.removeItem('IsAdet');
  sessionStorage.setItem('IsAdet', Adet);
};
export const setClosedJobCount = (count) => {
  sessionStorage.removeItem('ClosedJobCount');
  sessionStorage.setItem('ClosedJobCount', count);
};

// //////////////// UYARI ///////////////////////

export const getUyariAdet = () => sessionStorage.getItem('UyariAdet') || null;

export const setUyariAdet = (Adet) => {
  sessionStorage.removeItem('UyariAdet');
  sessionStorage.setItem('UyariAdet', Adet);
};

// //////////////// MALZEME IHTIYAÇ ///////////////////////

export const getMalzemeIhtiyacAdet = () => sessionStorage.getItem('MalzemeIhtiyacAdet') || null;

export const setMalzemeIhtiyacAdet = (Adet) => {
  sessionStorage.removeItem('MalzemeIhtiyacAdet');
  sessionStorage.setItem('MalzemeIhtiyacAdet', Adet);
};


// ////////////// YORUM /////////////////////////////

export const getYorumAdet = () => sessionStorage.getItem('YorumAdet') || null;

export const setYorumAdet = (Adet) => {
  sessionStorage.removeItem('YorumAdet');
  sessionStorage.setItem('YorumAdet', Adet);
};
